var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Vector","d":"M15.2492 0.75H18.0482L11.9331 7.73923L19.1271 17.25H13.4942L9.0824 11.4818L4.03428 17.25H1.23351L7.77428 9.77423L0.873047 0.75H6.64889L10.6368 6.02238L15.2492 0.75ZM14.2668 15.5746H15.8178L5.80612 2.33738H4.14174L14.2668 15.5746Z","fill":"white"}));
}

Twitter.defaultProps = {"width":"20","height":"18","viewBox":"0 0 20 18","fill":"none"};

module.exports = Twitter;

Twitter.default = Twitter;
